import { Badge } from "@mantine/core";

import knowledgeBadge from "@/sales-tools/challenges/icons/KnowledgeBadge.svg";
import soloAnimatedBadge from "@/sales-tools/challenges/icons/SoloAnimatedBadge.svg";
import soloBadge from "@/sales-tools/challenges/icons/SoloBadge.png";
import teamAnimatedBadge from "@/sales-tools/challenges/icons/TeamAnimatedBadge.svg";
import teamBadge from "@/sales-tools/challenges/icons/TeamBadge.png";

export const getBadgeIcon = (badgeType: string) => {
    switch (badgeType) {
        case "GOLD_MEDAL":
            return teamBadge;
        case "GOLD_STAR":
            return soloBadge;
        case "SOLO_ANIMATED_BADGE":
            return soloAnimatedBadge;
        case "TEAM_ANIMATED_BADGE":
            return teamAnimatedBadge;
        case "SCHOLAR":
            return knowledgeBadge;
        default:
            return <Badge color="dark.7" circle w={48} h={48} />;
    }
};
